import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import VeeValidatePlugin from "@/plugin/VeeValidatePlugin";

//Manage Head
import { createHead } from "@vueuse/head";
//Google Tag Manager
import { createGtm } from "vue-gtm";
// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

const head = createHead();

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});

Amplify.configure(awsExports);
createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(VeeValidatePlugin)
  .use(head)
  .use(
    createGtm({
      id: "GTM-KLK59PS",
    })
  )
  .mount("#app");
